const targetEmpty = (props) => 
{
    if (props.target && props.target.length) return false;
    return true;
};

export default targetEmpty;
